import { useRouter } from '@/routing/useAppRouter';
import { useState } from 'react';

import { ADMIN_DEFAULT_SORT_COUNT } from '@/data/shared/constant';

import type {
  PaginationData,
  PaginationSelected,
} from '@/components/admin/ui/pagination/types';

export function createPaginationRoute(
  pathname: string,
  query: Record<string, string | string[] | undefined>,
  selectedPage: PaginationSelected,
) {
  return {
    pathname,
    query: {
      ...query,
      page: String(selectedPage.selected + 1),
    },
  };
}

export default function usePagination<ResultType>({
  data,
  sortingCount = ADMIN_DEFAULT_SORT_COUNT,
}: PaginationData<ResultType>) {
  const router = useRouter();

  const dataPage = data?.page || 1;
  const [manualPage, setManualPage] = useState<{
    dataPage: number;
    page: number;
  } | null>(null);
  const currentPage =
    manualPage?.dataPage === dataPage ? manualPage.page : dataPage;
  const total = data?.total || 0;
  const pageCount = Math.ceil(total / sortingCount);

  // 라우팅 이동 시 페이지네이션 핸들러 함수 (페이지네이션 이동)
  const onPageChangeRouter = (selectedPage: PaginationSelected) => {
    router.push(
      createPaginationRoute(router.pathname, router.query, selectedPage),
    );
  };

  // 정적 페이지네이션 핸들러 함수
  const onPageChange = (selectedPage: PaginationSelected) => {
    setManualPage({ dataPage, page: selectedPage.selected + 1 });
  };

  return {
    paginationData: { currentPage, pageCount, total },
    onPageChangeRouter,
    onPageChange,
  };
}
